import z from 'zod';

export const createPaginatedSchema = <T extends z.ZodTypeAny>(itemSchema: T) =>
  z.object({
    items: z.array(itemSchema),
    total_count: z.number(),
  });

// 배너 생성
export const BannerTemplateSchema = z.enum([
  'basic',
  'emphasis',
  'info',
  'image_heavy',
]);
export const BannerBackgroundSchema = z.enum([
  'white',
  'solid',
  'gradient',
  'object',
]);

export type BannerTemplate = z.infer<typeof BannerTemplateSchema>;
export type BannerBackground = z.infer<typeof BannerBackgroundSchema>;
